import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface MetricCardProps {
  label: string;
  value: string;
  subValue?: string;
  trend?: 'positive' | 'negative' | 'neutral';
  size?: 'default' | 'large';
  className?: string;
}

export function MetricCard({
  label,
  value,
  subValue,
  trend = 'neutral',
  size = 'default',
  className
}: MetricCardProps) {
  return (
    <div className={cn('', className)}>
      <span className="metric-label block mb-2">{label}</span>
      <motion.span
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className={cn(
          size === 'large' ? 'metric-value-display' : 'metric-value',
          trend === 'positive' && 'text-positive',
          trend === 'negative' && 'text-negative'
        )}
      >
        {value}
      </motion.span>
      {subValue && (
        <span className="block mt-1 text-small text-foreground-muted">
          {subValue}
        </span>
      )}
    </div>
  );
}